<script lang="ts">
    import { onMount } from "svelte";
    import { Chart as FrappeChart } from "frappe-charts/dist/frappe-charts.min.esm";

    // Props via $props()
    type ChartParams = {
        labels: string[];
        values: Array<number | string>;
        units?: string;
    };

    type ChartProps = {
        params: ChartParams;
        type: string;
        chartId: string;
        height: number;
        currentRange?: string;
    };

    let { params, type, chartId, height, currentRange }: ChartProps = $props();

    let chartHost: HTMLDivElement | null = $state(null);
    let resizeObserver: ResizeObserver | null = null;
    let lastHostWidth = 0;
    let pendingResizeRaf: number | null = null;

    onMount(() => {
        setChart();

        if (typeof ResizeObserver !== "undefined") {
            resizeObserver = new ResizeObserver((entries) => {
                const entry = entries[0];
                const width = Math.round(entry?.contentRect?.width || 0);
                if (!width || width === lastHostWidth) return;
                lastHostWidth = width;

                if (pendingResizeRaf) cancelAnimationFrame(pendingResizeRaf);
                pendingResizeRaf = requestAnimationFrame(() => {
                    pendingResizeRaf = null;
                    setChart();
                });
            });

            if (chartHost) resizeObserver.observe(chartHost);
        }

        return () => {
            if (pendingResizeRaf) cancelAnimationFrame(pendingResizeRaf);
            pendingResizeRaf = null;
            if (resizeObserver) resizeObserver.disconnect();
            resizeObserver = null;
        };
    });

    $effect(() => {
        setChart();
    });

    function setChart() {
        if (chartId && params?.values?.length > 0) {
            setTimeout(() => {
                const el = document.getElementById(chartId);
                if (el) el.innerHTML = "";
                new FrappeChart(`#${chartId}`, {
                    data: {
                        labels: params.labels,
                        datasets: [
                            {
                                type,
                                values: params.values,
                            },
                        ],
                    },
                    height,
                    type,
                    barOptions: {
                        spaceRatio: 0.5,
                    },
                    axisOptions: {
                        xIsSeries: 1,
                        xAxisMode: "tick",
                    },
                    tooltipOptions: {
                        formatTooltipY: (d: number) =>
                            `${d} ${params.units || ""}`,
                    },
                    lineOptions: {
                        regionFill: 0,
                    },
                    colors: ["#4CE39D", "#88F7C4", "#C5FDE3"],
                    valuesOverPoints: 1,
                });
            }, 0);
        }
    }
</script>

<div class="chart" bind:this={chartHost}>
    <div
        id={chartId}
        style="
      height: 100%;
      {currentRange === 'custom'
            ? params.values.length < 5
                ? 'width:100%'
                : `width:${params.values.length * 85}px !important;`
            : ''}
    "
    ></div>
</div>

<style lang="scss">
    @use "./styles/index.scss";
</style>
